import { render, staticRenderFns } from "./ArchivedCategories.vue?vue&type=template&id=3805195e&scoped=true&"
import script from "./ArchivedCategories.vue?vue&type=script&lang=js&"
export * from "./ArchivedCategories.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedCategories.vue?vue&type=style&index=0&id=3805195e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3805195e",
  null
  
)

export default component.exports